import { i18n } from '@senderra/translations';
import { Filters } from '../../../types';
import { Product } from '../../products/api/types';

export const availableRoles = ['TenantAdmin', 'PortalUser', 'PlatformAdmin'] as const;

export enum UserStatus {
    ACTIVE = 'Active',
    PENDING = 'Pending',
}

export interface User {
    firstName: string;
    lastName: string;
    title: string;
    phoneNumber: string;
    avatarLink: string;
    id: string;
    email: string;
    isLocked: boolean;
    status: typeof UserStatus[keyof typeof UserStatus];
    roleName: (typeof availableRoles)[number];
    tenantName: string;
    tenantId: number;
    products: Array<Product>;
}

export interface UserManagementResponse {
    totalCount: number;
    value: User[];
}

export interface UserManagementProps extends Filters {
    name: string;
    status: 'Active' | 'Pending' | 'none';
    state: boolean | 'none';
drugShortNames: Array<string>;
}

export enum UserType {
    ADMIN = 'Admin',
    USER = 'User',
    PlatformAdmin = 'PlatformAdmin',
}

export const roleMapper: { [key in UserType]: string } = {
    [UserType.ADMIN]: i18n.t('tenant-admin'),
    [UserType.USER]: i18n.t('frm-full'),
    [UserType.PlatformAdmin]: i18n.t('portal-admin'),
};

export const reverseRoleMapper: { [key: string]: UserType } = {
    TenantAdmin: UserType.ADMIN,
    PortalUser: UserType.USER,
    PlatformAdmin: UserType.PlatformAdmin,
};

export const roleLabel: { [key: string]: string } = {
    TenantAdmin: i18n.t('tenant-admin'),
    PortalUser:  i18n.t('frm'),
    PlatformAdmin: i18n.t('portal-admin'),
};

export interface UserInviteFormValues {
    email: string;
    firstName: string;
    lastName: string;
    phoneNumber: string;
    type: UserType | string;
    title: string;
    products?: Array<Product>;
}

export const FILE_STATUSES = {
    NEW: 'New',
    RUNNING: 'Running',
    COMPLETED: 'Completed',
    FAILED: 'Failed',
} as const;

export const RECORD_STATUSES = {
    OK: 'Ok',
    INVALID: 'Invalid',
    CONFLICT: 'Conflict',
} as const;

export interface ImportUsersStatus {
    status: (typeof FILE_STATUSES)[keyof typeof FILE_STATUSES];
    failReason: string;
    succeedCount: number;
    errors: {
        [key: string]: {
            isSuccess: boolean;
            status: (typeof RECORD_STATUSES)[keyof typeof RECORD_STATUSES];
            errors: string;
        };
    };
    createdAt: string;
    startedAt: string;
    finishedAt: string;
}

export interface ImportUsersJob {
    jobId: string;
}

export interface ImportedUsersFile {
    fileLink: 'string';
}
